export default 'chatExample'
